export const SUBSCRIPTION_URLS = {
    details: () => '/subscription/details',
    get: () => '/subscription',
    usage: () => '/subscription/usage',
    activate: () => '/subscription/activate',
    update: () => '/subscription',
};
